import { useEffect } from "react";

function GenesysMessenger() {
  useEffect(() => {
    // Evita cargarlo dos veces
    if (window.Genesys || document.getElementById("genesys-messenger-script")) {
      return;
    }

    (function (g, e, n, es, ys) {
      g["_genesysJs"] = e;
      g[e] =
        g[e] ||
        function () {
          (g[e].q = g[e].q || []).push(arguments);
        };
      g[e].t = 1 * new Date();
      g[e].c = es;

      ys = document.createElement("script");
      ys.async = 1;
      ys.src = n;
      ys.charset = "utf-8";
      ys.id = "genesys-messenger-script";
      document.head.appendChild(ys);
    })(
      window,
      "Genesys",
      "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js",
      {
        environment: "prod",
        deploymentId: "710c3e36-97f3-419e-a16b-32badedc1726",
      }
    );
  }, []);

  return null;
}

export default GenesysMessenger;